import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Button, Box, Typography, Container } from "@mui/material";
import CustomSwitch from "../../components/CustomSwitch/CustomSwitch";
import CircleWithTick from "../../components/CircleWithTick/CircleWithTick";
import MenuService from "../../components/Menu/menuService";
import DialogService from "../../components/Dialog/dialogService";
import PremiumBadge from "../../img/icons/vip.png";
import { setSubscriptionState } from "./subscriptionSlice";

type PlanDataType = {
  title: string;
  basicPlan: string | "CheckMark" | "GreyCheckMark";
  vipPlan: string | "CheckMark";
  height: number;
};

const PlanData: PlanDataType[] = [
  {
    title: "Upload and manage collection",
    basicPlan: "Unlimited number of shirts",
    vipPlan: "Unlimited number of shirts",
    height: 70,
  },
  {
    title: "Collection visibility",
    basicPlan: "Collection is publicly visible",
    vipPlan: "Collection/shirts may be private",
    height: 70,
  },
  {
    title: "Rank shirts (Top 10)",
    basicPlan: "CheckMark",
    vipPlan: "CheckMark",
    height: 70,
  },
  {
    title: "Chat with, discuss (through the forum) and follow other collectors",
    basicPlan: "CheckMark",
    vipPlan: "CheckMark",
    height: 100,
  },
  {
    title: "You may receive irresistible offers for your shirts",
    basicPlan: "Receive irresistible offers for all your shirts",
    vipPlan: "Option to unlist your shirts as not for sale",
    height: 70,
  },
  {
    title: "Contribute to the social media environment",
    basicPlan: "CheckMark",
    vipPlan: "CheckMark",
    height: 70,
  },
  {
    title:
      "Scroll through all shirt sales and selling prices from shirts sold on Ebay (more platforms coming soon).",
    basicPlan: "CheckMark",
    vipPlan: "CheckMark",
    height: 120,
  },
  {
    title: "Collection STATS",
    basicPlan: "Only for your first 10 shirts",
    vipPlan: "For all your shirts",
    height: 70,
  },
  {
    title:
      "Automatically track the value and profit of your shirts(collection)",
    basicPlan: "Only for your first 10 shirts",
    vipPlan: "For all your shirts",
    height: 120,
  },
  {
    title: "Perform Legit Checks on other shirts",
    basicPlan: "GreyCheckMark",
    vipPlan: "CheckMark",
    height: 80,
  },
];

const UpgradeMembership = () => {
  const dispatch = useDispatch();
  const [isMonthly, setIsMonthly] = useState<boolean>(true);

  const { selectPage } = MenuService();
  const { close } = DialogService();

  useEffect(() => {
    selectPage("upgrade-membership");
    close();
  }, []);

  useEffect(() => {
    dispatch(setSubscriptionState(isMonthly));
  }, [isMonthly]);

  return (
    <Container maxWidth={false} sx={{ backgroundColor: "#f4f6f8" }}>
      <Container
        maxWidth="lg"
        sx={{
          paddingY: "2rem",
          paddingX: "0px !important",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: { xs: "block", sm: "flex" },
            justifyContent: "space-between",
            alignItems: "flex-end",
            paddingBottom: "32px",
            borderBottom: "2px solid #e3e0e0",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: { xs: "100%", sm: "fit-content" },
              justifyContent: "left",
            }}
          >
            <Typography variant="upgradeTitle" textAlign="start">
              Subscriptions
            </Typography>
            <Typography variant="upgradeSubtitle" textAlign="start">
              Choose the subscription that suits you
            </Typography>
          </Box>
          <Box
            sx={{
              display: { xs: "block", sm: "flex" },
              flexDirection: "row",
              width: { xs: "100%", sm: "fit-content" },
              alignItems: "flex-end",
              justifyContent: "right",
              columnGap: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                columnGap: 1,
                marginY: { xs: "10px", sm: "0px" },
              }}
            >
              <CustomSwitch
                checked={!isMonthly}
                onChange={(e) => setIsMonthly(!e.target.checked)}
              />
              <Typography variant="upgradeSubtitle">
                Pay per year (saves you 16.6%)
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", columnGap: 1 }}>
              <CustomSwitch
                checked={isMonthly}
                onChange={(e) => setIsMonthly(e.target.checked)}
              />
              <Typography variant="upgradeSubtitle">Pay per month</Typography>
            </Box>
          </Box>
        </Box>

        <Box sx={{ overflowX: { xs: "auto", sm: "auto", md: "hidden" } }}>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              paddingTop: "32px",
              justifyContent: "space-between",
              columnGap: 1,
            }}
          >
            <Box
              sx={{
                width: "calc(33.33% - 8px)",
                minWidth: "240px",
                padding: {
                  xs: "1rem 1rem 1rem 0rem",
                  sm: "2rem 2rem 2rem 0rem",
                },
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  fontWeight: "bold !important",
                  marginTop: "15px",
                  visibility: "hidden",
                }}
              >
                Placeholder
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  marginBottom: "20px",
                  visibility: "hidden",
                }}
              >
                Placeholder
              </Typography>
              <Typography
                variant="h3"
                sx={{
                  fontWeight: "bold !important",
                  textShadow: "none",
                  color: "#4663ff",
                  marginBottom: "20px",
                  visibility: "hidden",
                }}
              >
                Placeholder
              </Typography>

              {PlanData.map((plan, index) => (
                <Box
                  key={`pricingPlanDesc_${index}`}
                  sx={{
                    height: `${plan.height}px`,
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      display: "block",
                      fontSize: "1rem",
                      fontWeight: 400,
                      lineHeight: 1.2,
                    }}
                  >
                    {plan.title}
                  </Typography>
                </Box>
              ))}
            </Box>

            <Box
              className="shadow-box"
              sx={{
                width: "calc(33.33% - 8px)",
                minWidth: "290px",
                padding: { xs: "1rem", sm: "2rem" },
                borderRadius: "16px",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                backgroundColor: "#fff",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  fontWeight: "bold !important",
                  marginTop: "15px",
                }}
              >
                Basic collector
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  marginBottom: "20px",
                }}
              >
                For beginning collectors
              </Typography>
              <Typography
                variant="h3"
                sx={{
                  fontWeight: "bold !important",
                  textShadow: "none",
                  color: "#4663ff",
                  marginBottom: "20px",
                }}
              >
                Free
              </Typography>

              {PlanData.map((plan, index) => (
                <Box
                  key={`pricingPlanBasic_${index}`}
                  sx={{
                    height: `${plan.height}px`,
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  {plan.basicPlan === "CheckMark" ? (
                    <CircleWithTick circleColor="#4663ff" />
                  ) : plan.basicPlan === "GreyCheckMark" ? (
                    <CircleWithTick circleColor="#edeef0" />
                  ) : (
                    <Typography
                      sx={{
                        display: "block",
                        fontSize: "1rem",
                        fontWeight: 400,
                        lineHeight: 1.2,
                      }}
                    >
                      {plan.basicPlan}
                    </Typography>
                  )}
                </Box>
              ))}
            </Box>

            <Box
              className="shadow-box"
              sx={{
                width: "calc(33.33% - 8px)",
                minWidth: "290px",
                padding: { xs: "1rem", sm: "2rem" },
                borderRadius: "16px",
                display: "flex",
                flexDirection: "column",
                background:
                  "linear-gradient(to top right, rgba(230,195,5,1) 15%, rgba(244,238,50,1) 75%, rgba(169,183,115,1) 100%)",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "start",
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: "bold !important",
                    marginTop: "15px",
                  }}
                >
                  VIP collector
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    marginBottom: "20px",
                  }}
                >
                  For serious collectors
                </Typography>
                <Typography
                  variant="h3"
                  gutterBottom
                  sx={{
                    fontWeight: "bold !important",
                    marginBottom: "20px",
                  }}
                >
                  {isMonthly ? "€5 p/m" : "€50 p/y"}
                </Typography>
                {PlanData.map((plan, index) => (
                  <Box
                    key={`pricingPlanVip_${index}`}
                    sx={{
                      height: `${plan.height}px`,
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                    }}
                  >
                    {plan.vipPlan === "CheckMark" ? (
                      <CircleWithTick circleColor="#4663ff" />
                    ) : (
                      <Typography
                        sx={{
                          display: "block",
                          fontSize: "1rem",
                          fontWeight: 400,
                          lineHeight: 1.2,
                        }}
                      >
                        {plan.vipPlan}
                      </Typography>
                    )}
                  </Box>
                ))}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <Link to="/checkout" style={{ width: "90%" }}>
                  <Button
                    fullWidth
                    variant="premium"
                    sx={{
                      marginTop: "50px",
                      borderRadius: 2,
                      backgroundColor: "white !important",
                      background: "white !important",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        columnGap: 1,
                        width: "100%",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Box>{"UPGRADE"}</Box>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <img
                          loading="lazy"
                          width="20"
                          src={PremiumBadge}
                          alt=""
                        />
                      </Box>
                    </Box>
                  </Button>
                </Link>
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </Container>
  );
};

export default UpgradeMembership;
